<template>
<div>
    <!-- CALIDAD -->
    <v-img :src="require('@/assets/maya/inicio/inicio.jpg')" max-height="260" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                Servicios
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-medium" style="max-width:480px; line-height:1.3">
                <div>EMPRESA CERTIFICADA</div>
                <div>ISO 9001 - 2015</div>
            </div>
        </v-card>
    </v-img>

    <div class="accent darken-2 mb-n6 px-12 px-sm-0 pb-10 pb-sm-0">
        <v-row>
            <v-col cols="12" sm="8">
                <v-row class="d-flex justify-center mt-sm-6">
                    <v-col cols="12" sm="4">
                        <div class="d-flex justify-sm-end justify-center">
                            <div>
                                <v-img :src="require('@/assets/maya/servicios/icono_casco.png')" width="140"></v-img>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="5">
                        <div class="white--text body-1 font-weight-medium text-center mt-4 px-4" style="line-height:1.3">
                            ¿Qué podemos hacer por cada una de las industrias que día a día confían en MSO?
                        </div>
                        <div class="mt-6 mt-sm-4 d-flex justify-center">
                            <v-btn text class="white--text accent" href="https://firebasestorage.googleapis.com/v0/b/msorting-193e2.appspot.com/o/BROCHURE_NVO-TL.pdf?alt=media&token=52fe9cf8-5fa5-4208-a9fb-7afbdcbc9893" target="_blank">
                                <div class="d-flex align-center">
                                    <v-icon size="14" class="mr-3 mt-1">fa-cloud-download-alt</v-icon>
                                    <div>Descarga el brochure</div>
                                </div>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="4" v-if="$vuetify.breakpoint.smAndUp">
                <div class="d-flex justify-end mt-n8 mr-md-12">
                    <div class="mt-n12 mr-md-12">
                        <v-img :src="require('@/assets/maya/servicios/trabajador.png')" width="280"></v-img>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>

    <v-row class="px-6 px-sm-0 mb-8" no-gutters>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/gp12')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/gp12.jpg')" height="180"></v-img>
                <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        GP12
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/incoming-inspection')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/incomingInspection.jpg')" height="180"></v-img>
                <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Incoming Inspection
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/cs1-cs2')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/cs.jpg')" height="180"></v-img>
                <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        CS1 y CS2
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/retrabajo')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/retrabajos.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Retrabajo
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/sorteos')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/sorteos.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Sorteos
                    </div>
                </div>
            </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/ensambles')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/ensambles.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Ensambles
                    </div>
                </div>
            </v-card>
        </v-col> -->
        <!-- <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/fulfillment')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/fulfillment.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Fulfillment
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/limpieza')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/limpieza.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Limpieza
                    </div>
                </div>
            </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="3" @click="$router.push('/servicios/residentes')">
            <v-card flat tile class="transparent" style="border:2px solid black" hover>
                <v-img :src="require('@/assets/maya/servicios/shorts/residentes.jpg')" height="180"></v-img>
                 <div class="d-flex align-center grey darken-1 px-3 py-2 ">
                    <div><v-img :src="require('@/assets/maya/_/lupa-blanca.png')" contain width="14px"></v-img></div>
                    <div class="white--text font-weight-medium ml-2 mt-1">
                        Residentes
                    </div>
                </div>
            </v-card>
        </v-col> -->
    </v-row>
</div>
</template>

<script>
export default {
    metaInfo: {
      title: 'Servicios'
    }
}
</script>

